import React from 'react';

import {DropdownHeader} from "./dropdown-header";
import {DropdownComposer} from "./dropdown-composer";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {BaseModel} from "../../../infrastructure/models/base-model";
import {List, ListProps} from "../misc/list/list";
import {ScrollBlocker} from "../misc/blockers/scroll-blocker";
import {ListItem} from "../misc/list/list-item";
import {WithDevice} from "../composers/with-device";
import {DeviceViewModel} from "../../models/device.view-model";
import classNames from "classnames";
import styles from "./styles/dropdown.module.scss";

export class DropdownProps extends BaseProps {
  containerClassName: String;
  headerClassName: String;
  listClassName: String;
  itemClassName: String;
  headerItemClassName: String;
  items: Array<BaseModel>;
  selectedItem: BaseModel;
  ListItem: React.Component;
  listItemProps: Object;
  showBlanket: Boolean;
  device: DeviceViewModel;
  opened: Boolean;
  blockScrolling: Boolean;
  blockScrollToTop: Boolean;
  DownArrow: React.Component;
  UpArrow: React.Component;
  arrowUpClassName: String;
  arrowDownClassName: String;
  arrowContainerClassName: String;
  arrowColor: String;
  onChange: Function;
  toggleOpen: Function;
  close: Function;
}

export const Dropdown = WithDevice(DropdownComposer((props: DropdownProps) => {
  const scrollBlockerComponentProps = {
    onDisable: () => props.close(),
    blanket: props.showBlanket,
    blockScrolling: props.blockScrolling && props.device.isSmallView,
    blockScrollToTop: props.blockScrollToTop && props.device.isSmallView,
  }

  const dropdownHeaderComponentProps = {
    className: props.headerItemClassName,
    containerClassName: classNames(styles.header, {'clickable': props.items.length > 0}, props.headerClassName),
    selectedItem: props.selectedItem,
    ListItem: props.ListItem || ListItem,
    listItemProps: props.listItemProps,
    expandable: props.items.length > 0,
    opened: props.opened,
    toggleOpen: props.toggleOpen,
    arrowColor: props.arrowColor,
    arrowUpClassName: props.arrowUpClassName,
    arrowDownClassName: props.arrowDownClassName,
    arrowContainerClassName: props.arrowContainerClassName,
  }

  const listProps: ListProps = {
    items: props.items,
    selectedItem: props.selectedItem,
    ListItem: props.ListItem || ListItem,
    listItemProps: props.listItemProps,
    className: classNames(styles.list, props.listClassName),
    itemClassName: props.itemClassName,
    onChange: (item) => props.items.length > 0 && props.onChange(item),
    shouldUseScrollbar: true
  }

  return (
    <div className={classNames(styles.container, {'clickable' : props.items.length > 0}, {[styles.opened_container]:props.opened} , props.containerClassName)}>
      {
        props.opened && <ScrollBlocker {...scrollBlockerComponentProps}/>
      }
      <DropdownHeader {...dropdownHeaderComponentProps}/>
      {
        props.items.length > 0 && props.opened && <List {...listProps}/>
      }
    </div>
  )
}));
